/**
 * @description Returns true if the string contains only digits from 0 to 9
 */
export const containsOnlyNumbers = (str: string) => /^\d+$/.test(str)
